import { createPermission } from "@backstage/plugin-permission-common";

// Defines a number of things, including the base url of the backend API
export const pluginId = "gcp-project-approvals";

export const gcpApprovalsUpdate = createPermission({
    name: `${pluginId}.approvals.update`,
    attributes: { action: "update" },
});

/**
 * List of all available permissions
 *
 * @public
 */
export const permissions = [gcpApprovalsUpdate];
